<template>
  <div>
    <equipment-edit v-model="fermenter" title="Fermenter" :sites="sites"
                    @save="save" :loading="loading" :saving="saving" :dirty.sync="dirty">
      <v-row dense>
        <v-col cols="6" sm="3" md="2">
          <decimal-number-input label="Capacity" v-model="fermenter.capacity" prefix="" suffix="litres" :precision="0" integer/>
        </v-col>
      </v-row>
      <v-row v-if="connectedToAccounting && values" dense>
        <v-col cols="12" sm="6" md="4">
          <account-picker v-model="fermenter.inventoryAccountRef" label="Inventory asset account"
                          :accounts="accounts" :addTypes="['OtherCurrentAsset']"
                          hint="The inventory account used to track the value of this fermenter's contents"/>
        </v-col>
      </v-row>

      <div v-if="fermenterId==undefined" :class="{'mb-4':!showInitial}">
        <v-row dense class="mt-4">
          <v-col>
            <v-btn icon small class="mt-n1" @click="showInitial=!showInitial"><v-icon>mdi-menu-down</v-icon></v-btn>Initial contents
          </v-col>
        </v-row>
        <v-slide-y-transition>
          <v-row v-show="showInitial" dense class="ml-4">
            <v-col cols="6" sm="3" md="2">
              <decimal-number-input label="Volume" v-model="initial.volume" prefix="" suffix="litres" :precision="0" integer/>
            </v-col>
            <v-col cols="6" sm="3" md="2">
              <decimal-number-input label="Value" v-model="initial.value"/>
            </v-col>
            <v-col cols="6" sm="3" md="2">
              <v-text-field outlined dense label="Lot" v-model="initial.lot" :rules="[fieldRules.required,fieldRules.maxLength(20)]"/>
            </v-col>
            <v-col cols="6" sm="3">
              <date-picker label="As of" v-model="initial.asof"/>
            </v-col>
          </v-row>
        </v-slide-y-transition>
      </div>

    </equipment-edit>

    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import {format} from 'date-fns'
import EquipmentEdit from '@/views/equipment/EquipmentEdit'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'EquipmentFermentersEdit',
  mixins: [confirmLeave],
  components: {EquipmentEdit},
  props: {
    fermenterId: {type:String, required:false}
  },
  data () {
    return {
      accounts: [],
      fermenter: {name:'',active:true,siteId:'',inventoryAccountRef:'',capacity:1000,
                  manufacturer:'',modelNumber:'',serialNumber:'',
                  maintenance:{frequency:0,frequencyUnits:'never',nextDate:format(new Date(), 'yyyy-MM-dd'),description:''}},

      initial: {asof:format(new Date(), 'yyyy-MM-dd HH:mm:ss'),volume:0,value:0,lot:''},
      dirty: false,
      saving: false,
      loading: false,
      showInitial: false
    }
  },
  computed: {
    sites() {
      return this.$store.getters.sites(!this.fermenterId, {B265:true,B266:true});
    },
    values() {
      return this.$store.getters.company.permissions.includes('values') && this.$store.getters.company.settings.useAccounts;
    },
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    }
  },
  async created() {
    this.loading = true;
    const results = await this.$apiCall(`query EquipmentFermentersEdit($currency:String!, $accounting:Boolean!, $edit:Boolean!, $id:ID!) {
                                              accounts(currency:$currency) @include(if:$accounting) {
                                                ref,name,type
                                              }
                                              companyAccounts @skip(if:$edit) {fermenterInventory}
                                              lotUnique(prefix:"M") @skip(if:$edit)
                                              fermenter(id:$id) @include(if:$edit) {
                                                id,name,active,capacity,site{id},
                                                inventoryAccountRef,pictureURL,
                                                manufacturer,modelNumber,serialNumber,
                                                maintenance {frequency,frequencyUnits,nextDate,description}
                                              }
                                            }`,
                                        {accounting:this.connectedToAccounting, currency:this.$store.getters.company.settings.homeCurrency,
                                          edit:this.fermenterId!=undefined,id:this.fermenterId?this.fermenterId:''});
    if (results.error) {
      this.$nextTick(() => {this.dirty = false});
      this.$router.back();
      return;
    }
    if (this.connectedToAccounting)
      this.accounts = results.data.accounts.filter(account => account.type === 'OtherCurrentAsset');

    if (this.fermenterId)
      this.fermenter = {...results.data.fermenter, siteId:results.data.fermenter.site.id, site:undefined};
    else {
      this.fermenter.siteId = this.sites[0].id;
      this.fermenter.inventoryAccountRef = results.data.companyAccounts.fermenterInventory;
      this.initial.lot = results.data.lotUnique;
    }
    this.$nextTick(() => {this.dirty = false});
    this.loading = false;
  },

  methods: {
    cancel() {
      this.$router.back();
    },
    async save() {
      this.saving = true;
      // eslint-disable-next-line no-unused-vars
      const {pictureURL, ...input} = this.fermenter;
      if (!this.fermenterId && this.initial.volume)
        input.initial = this.initial;
      const results = await this.$apiCall(`mutation EquipmentFermentersEdit($input: FermenterInput!) {
                                             fermenterCreate(input:$input) {id}
                                           }`,
                                          {input})
      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.fermenter.id?'Updated':'Created'} fermenter ${this.fermenter.name}`});
      }
    }
  }
}
</script>